import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import DesignerButton from './DesignerButton';

class TermsOfService extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      email: '',
    };
  }

  handleGoBack = () => {
    this.props.navigate(`/`);
  };

  render() {
    return (
      <div className="PrivacyPolicyHome">
        <h1 className="PrivacyPolicyH1">Word Cup Terms of Service</h1>

        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBack}></DesignerButton>
        </div>

        <label className="PrivacyPolicyText">
        Effective Date: 06/24/2023<br />
1. Introduction<br />
Welcome to WordCup ("the Game"). The Game is operated by Gametertainment Studio OOD. ("we," "us," "our"). By accessing or using the Game, you agree to comply with and be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Game.<br />
2. Eligibility<br />
You must be at least 4 years old to use the Game. By using the Game, you represent and warrant that you meet this age requirement.<br />
3. Account Registration<br />
To access certain features of the Game, you may be required to register for an account. You agree to provide accurate and complete information when creating an account and to keep this information up to date. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.<br />
4. Use of the Game<br />
You agree to use the Game in compliance with all applicable laws and regulations. You must not:<br />
	•	Use the Game for any unlawful purpose.<br />
	•	Engage in any activity that could harm, disrupt, or interfere with the Game or its servers.<br />
	•	Attempt to gain unauthorized access to any part of the Game.<br />
5. User Conduct<br />
You agree to respect other players and not engage in any behavior that is harmful, offensive, or inappropriate. This includes, but is not limited to:<br />
	•	Harassment, bullying, or threats.<br />
	•	Cheating or using unauthorized software.<br />
	•	Posting or sharing inappropriate content.<br />
6. Intellectual Property<br />
All content and materials in the Game, including but not limited to text, graphics, logos, and software, are the property of Gametertainment Studio OOD its licensors and are protected by intellectual property laws. You may not use, reproduce, or distribute any content from the Game without our prior written permission.<br />
7. Purchases and Payments<br />
If the Game includes in-app purchases, you agree to pay all fees and applicable taxes incurred by you or anyone using your account. All purchases are final and non-refundable, except as required by law.<br />
8. Termination<br />
We reserve the right to suspend or terminate your access to the Game at any time, with or without notice, for any reason, including if we believe you have violated these Terms.<br />
9. Disclaimer of Warranties<br />
The Game is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that the Game will be uninterrupted or error-free.<br />
10. Limitation of Liability<br />
To the fullest extent permitted by law, Gametertainment Studio OOD shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from (i) your use or inability to use the Game; (ii) any unauthorized access to or use of our servers and/or any personal information stored therein.<br />
11. Changes to These Terms<br />
We may update these Terms from time to time. We will notify you of any changes by posting the new Terms on this page. You are advised to review these Terms periodically for any changes. Your continued use of the Game after any changes constitutes your acceptance of the new Terms.<br />
12. Contact Us<br />
If you have any questions about these Terms, please contact us at the contact information below.<br />
Gametertainment Studio OOD<br />
BULGARIA, Sofia, Lozenetz, ul Nikolai Liliev, 12<br />
Et 1 office 2 Sofia, Sofia 142, Bulgaria<br />
contact@funfusionforge.com<br />

        </label>
      </div>
    );
  }
}

export default withCookies(TermsOfService);
